import { useState, useEffect, useRef } from "react";
import Header from "./Header";
import "./Css/ViewCardetails.css";
import { useLocation, useParams } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import GreyArrow from "../assets/greyLeftAr.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  check_vaild_save,
  combiled_form_data,
  empty_form,
  handleAphabetsChange,
  handleError,
  handleNumbersChange,
  handleSuccessSession,
} from "../CommonJquery/CommonJquery";
import Select from "react-select";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import cameraicon from "../assets/cameraicon.png";

import {
  APL_LINK,
  server_post_data,
  save_car_destails,
  cardetails_api_data,
  delete_multi_image,
} from "../ServiceConnection/serviceconnection.js";
import Loader from "./Loader.js";
export default function AddCarDetails() {
  const location = useLocation();
  const [carDetail, setcar] = useState([]);
  const { id } = useParams();
  const [images, setImages] = useState([]);
  const [imagesBackend, setImagesBackend] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [selectedExtraData, setSelectedExtraData] = useState("");
  const [editorData, setEditorData] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [cartype, setshowcartype] = useState([]);
  const [cardetails, setshowcardetails] = useState([]);
  const [carimage, setshowcarimage] = useState([]);
  const [carimagemulti, setshowcarimagemulti] = useState([]);
  const [error_show, seterror_show] = useState("");
  const [image, setImage] = useState(null);
  const [image2, setImage2] = useState(null);
  const [imageold, setImageold] = useState(null);
  const [gearType, setGearType] = useState("");
  const [fuleType, setFuleType] = useState("");
  const [seetCount, setSeetCount] = useState("");
  const [Model, setModel] = useState("");
  const [year, setYear] = useState(cardetails.year || "");

  const [color, setColor] = useState(cardetails.color || "");
  const [vin, setVin] = useState(cardetails.vin || "");
  const [registeredTo, setRegisteredTo] = useState(
    cardetails.registered_to || ""
  );
  const [registrationDate, setRegistrationDate] = useState(
    cardetails.registration_date || ""
  );
  const [renewalDate, setRenewalDate] = useState(cardetails.renewal_date || "");
  const [emissionsDue, setEmissionsDue] = useState(
    cardetails.emissions_due || ""
  );
  const [inspection, setInspection] = useState(cardetails.inspection || "");
  const [inspValidity, setInspValidity] = useState(
    cardetails.insp_validity || ""
  );
  const [company, setCompany] = useState(cardetails.company || "");

  const handleImageUpload = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setImagesBackend(selectedFiles);
    if (images.length + selectedFiles.length > 8) {
      alert("You can only upload a maximum of 8 images.");
      return;
    }
    const newImageUrls = selectedFiles.map((file) => URL.createObjectURL(file));
    setImages([...images, ...newImageUrls]);
  };

  // Handle image removal
  const handleImageRemove = async (index) => {
    let fd_from = new FormData();
    fd_from.append("name", index);
    await server_post_data(delete_multi_image, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get();
        }
      })
      .catch((error) => {
        console.log(error);
        setshowLoaderAdmin(false);
      });

    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
  };

  const [otherExtraData, setOtherExtraData] = useState("");

  // Options for React Select
  const options = [
    { value: "data", label: "data" },
    { value: "data2", label: "data2" },
    { value: "data3", label: "data3" },
    { value: "Other", label: "Other" },
  ];

  // Handle multi-select change

  // Handle input for "Other" field
  const handleOtherInputChange = (event) => {
    setOtherExtraData(event.target.value);
  };

  const isOtherSelected = selectedOptions.some(
    (option) => option.value === "Other"
  );
  const handleEditorChange = (event, editor) => {
    setEditorData(editor.getData());
  };

  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    vaild_data = true;
    if (vaild_data) {
      if (editorData.length > 0) {
        setshowLoaderAdmin(true);
        let fd_from = combiled_form_data(form_data, null);
        if (id !== undefined) {
          fd_from.append("call_id", id);
        }

        fd_from.append("message", editorData);
        imagesBackend.forEach((image, index) => {
          fd_from.append(`files`, image);
        });
        if (imageold !== null || (imageold && imageold?.length == 0)) {
          fd_from.append("image_old", imageold);
        } else {
          fd_from.append("image_old", "0");
        }
        fd_from.append("gear_type", gearType);
        fd_from.append("fule_type", fuleType);
        fd_from.append("total_seats", seetCount);
        fd_from.append("make_year", year);

        fd_from.append("color", color);
        fd_from.append("vin", vin);
        fd_from.append("registered_to", registeredTo);
        fd_from.append("registration_date", registrationDate);
        fd_from.append("renewal_date", renewalDate);
        fd_from.append("emissions_due", emissionsDue);
        fd_from.append("inspection", inspection);
        fd_from.append("insp_validity", inspValidity);
        fd_from.append("company", company);

        await server_post_data(url_for_save, fd_from)
          .then((Response) => {
            setshowLoaderAdmin(false);
            if (Response.data.error) {
              handleError(Response.data.message);
            } else {
              handleSuccessSession(Response.data.message, "/view_cardetails");
            }
          })
          .catch((error) => {
            console.log(error);
            setshowLoaderAdmin(false);
          });
      } else {
        seterror_show("Please Fill The Mandatory Information");
      }
    }
  };
  useEffect(() => {
    // if (id !== undefined) {
    master_data_get();
    // }
  }, []);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    if (id !== undefined) {
      fd.append("main_id", id);
    }
    fd.append("flag", 3);
    await server_post_data(cardetails_api_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setshowcartype(Response.data.message.car_type);
          if (Response.data.message.cardetais.length > 0) {
            setshowcarimagemulti(Response.data.message.multiimage);
            setshowcardetails(Response.data.message.cardetais[0]);
            setImageold(Response.data.message.cardetais[0].image);
            setGearType(Response.data.message.cardetais[0].gear_type);
            setFuleType(Response.data.message.cardetais[0].fuel_type);
            setSeetCount(Response.data.message.cardetais[0].seating_capacity);
            setModel(
              `${Response.data.message.cardetais[0].model_name}~@~${Response.data.message.cardetais[0].model_id}`
            );

            setImage2(
              APL_LINK +
                Response.data.message.car_image +
                Response.data.message.cardetais[0].image
            );
            setEditorData(Response.data.message.cardetais[0].car_description);
            setIsImageUploaded(true);
          }
          setshowcarimage(Response.data.message.car_image);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const fileInputRef = useRef(null);
  const handleImageUpload1 = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
        setImage2(null);
        setIsImageUploaded(true);
      };
      reader.readAsDataURL(file);
    }
  };
  const triggerFileInput = () => {
    fileInputRef.current.click();
  };
  const handleChange = (event) => {
    setGearType(event.target.value);
  };
  const handleChange1 = (event) => {
    setFuleType(event.target.value);
  };
  const handleChange2 = (event) => {
    setSeetCount(event.target.value);
  };

  const handleChange3 = (event) => {
    setModel(event.target.value);
  };

  const handleRegistrationDateChange = (date) => {
    setRegistrationDate(date);
  };

  const handleRenewalDateChange = (date) => {
    setRenewalDate(date);
  };

  const handleEmissionsDueChange = (date) => {
    setEmissionsDue(date);
  };

  const handleInspValidityChange = (date) => {
    setInspValidity(date);
  };
  return (
    <div>
      <Header />
      {showLoaderAdmin && <Loader />}
      <div className="page_content">
        <div className="page_content_container">
          <div className="pageCntn_head" style={{ top: "0px" }}>
            <div className="pageNameDiv">
              <p>
                {location.pathname.includes("/edit_cardetails") ? (
                  <p>Update Car</p>
                ) : (
                  <p>Add Car </p>
                )}
              </p>
              <img src={GreyArrow} alt="Rapid Car Leasing" />
            </div>
          </div>

          <div className="cardetailFormContrr">
            <div className="container-lg">
              <div className="row">
                <div className="col-lg-6 mt-3">
                  <div className="leftFormCar">
                    <form
                      className="createRightsForm car_add_modal"
                      id="createRightsForm"
                    >
                      <div className="row m-0">
                        <div className="imageandcarNamediv">
                          {" "}
                          <div className="col-md-6 ">
                            <div className="inpContainer">
                              {" "}
                              <div
                                className={`imageViewConter ${
                                  isImageUploaded ? "uploaded" : ""
                                }`}
                              >
                                {isImageUploaded ? (
                                  image2 === null ? (
                                    <img
                                      src={image}
                                      alt="Uploaded"
                                      onClick={triggerFileInput}
                                      style={{ cursor: "pointer" }}
                                    />
                                  ) : (
                                    <img
                                      src={image2}
                                      alt="Uploaded"
                                      onClick={triggerFileInput}
                                      style={{ cursor: "pointer" }}
                                    />
                                  )
                                ) : (
                                  <img
                                    src={cameraicon}
                                    alt="Camera Icon"
                                    className="cameraIcon"
                                    onClick={triggerFileInput}
                                    style={{ cursor: "pointer" }}
                                  />
                                )}
                                <input
                                  type="file"
                                  ref={fileInputRef}
                                  accept="image/*"
                                  name="image"
                                  style={{ display: "none" }}
                                  onChange={handleImageUpload1}
                                  className="trio_mandatory form-control"
                                />
                              </div>
                              <label className="imngTaggLine">
                                Upload Image
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 col-12">
                            <div className="inpContainer marginClass">
                              <div>
                                <label className="no_prsnl_id">
                                  Model
                                  <span>*</span>
                                </label>
                                <input
                                  type="text"
                                  name="car_name"
                                  placeholder="Enter Model "
                                  defaultValue={cardetails.car_name || ""}
                                  minLength={3}
                                  maxLength={75}
                                  className="trio_mandatory form-control"
                                  // onInput={handleAphabetsChange}
                                />
                                <span className="condition_error"></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Make Year
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="text"
                                name="Make_year"
                                placeholder="Enter Year"
                                maxLength={4}
                                value={year}
                                onChange={(e) => setYear(e.target.value)}
                                className="trio_mandatory form-control"
                                onInput={handleNumbersChange}
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Car Model Type
                              <span>*</span>
                            </label>
                            <div>
                              <select
                                name="car_model"
                                value={Model}
                                className="trio_mandatory form-control"
                                onChange={handleChange3}
                              >
                                <option value="" hidden>
                                  Select Car Type
                                </option>
                                {cartype &&
                                  cartype.length > 0 &&
                                  cartype.map((item, index) => (
                                    <option
                                      key={index}
                                      value={`${item.name}~@~${item.primary_id}`}
                                    >
                                      {item.name}
                                    </option>
                                  ))}
                              </select>
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Color
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="text"
                                name="color"
                                placeholder="Enter Color"
                                value={color}
                                onChange={(e) => setColor(e.target.value)}
                                className="trio_mandatory form-control"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Seat Count
                              <span>*</span>
                            </label>
                            <div>
                              <select
                                name="total_seats"
                                value={seetCount}
                                className="trio_mandatory form-control"
                                onChange={handleChange2}
                              >
                                <option value="" hidden>
                                  Select Seat Count
                                </option>
                                <option value="2">2 Seats</option>
                                <option value="4">4 Seats</option>
                                <option value="5">5 Seats</option>
                                <option value="7">7 Seats</option>
                              </select>
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              VIN
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="text"
                                name="vin"
                                placeholder="Enter VIN"
                                value={vin}
                                onChange={(e) => setVin(e.target.value)}
                                className="trio_mandatory form-control"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Tag Line
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="text"
                                name="car_tagline"
                                placeholder="Enter tag line"
                                defaultValue={cardetails.car_tagline || ""}
                                min={0}
                                className="trio_mandatory form-control"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              License Plate
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="text"
                                name="car_no"
                                placeholder="Enter LP Number"
                                defaultValue={cardetails.car_no || ""}
                                className="trio_mandatory form-control"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Registered To
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="text"
                                name="registered_to"
                                placeholder="Enter Registered To"
                                value={registeredTo}
                                onChange={(e) =>
                                  setRegisteredTo(e.target.value)
                                }
                                className="trio_mandatory form-control"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Price
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="number"
                                name="Price"
                                placeholder="Enter Price"
                                defaultValue={cardetails.Price || ""}
                                min={0}
                                className="trio_mandatory form-control"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Registration Date
                              <span>*</span>
                            </label>
                            <div>
                              <DatePicker
                                selected={registrationDate}
                                onChange={handleRegistrationDateChange}
                                className="trio_mandatory form-control"
                                dateFormat="yyyy-MM-dd"
                                placeholderText="Select Registration Date"
                                name="registration_date"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Mileage
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="number"
                                name="car_mileage"
                                placeholder="Enter Mileage"
                                defaultValue={cardetails.car_mileage || ""}
                                min={0}
                                className="trio_mandatory form-control"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Renewal Date
                              <span>*</span>
                            </label>
                            <div>
                              <DatePicker
                                selected={renewalDate}
                                onChange={handleRenewalDateChange}
                                className="trio_mandatory form-control"
                                dateFormat="yyyy-MM-dd"
                                placeholderText="Select Renewal Date"
                                name="renewal_date"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Luggage Capacity
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="number"
                                name="luggage_capacity"
                                placeholder="Enter Luggage Capacity"
                                defaultValue={cardetails.storage_capacity || ""}
                                min={0}
                                className="trio_mandatory form-control"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Emissions Due On
                              <span>*</span>
                            </label>
                            <div>
                              <DatePicker
                                selected={emissionsDue}
                                onChange={handleEmissionsDueChange}
                                className="trio_mandatory form-control"
                                dateFormat="yyyy-MM-dd"
                                placeholderText="Select Emissions Due Date"
                                name="emissions_due"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Number of Doors
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="number"
                                name="no_of_doors"
                                placeholder="Enter Number of Doors"
                                defaultValue={cardetails.no_of_door || ""}
                                min={0}
                                className="trio_mandatory form-control"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Inspection
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="text"
                                name="inspection"
                                placeholder="Enter Inspection Details"
                                value={inspection}
                                onChange={(e) => setInspection(e.target.value)}
                                className="trio_mandatory form-control"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Gear Type <span>*</span>
                            </label>
                            <div>
                              <select
                                name="gear_type"
                                value={gearType}
                                className="trio_mandatory form-control"
                                onChange={(e) => handleChange(e)}
                              >
                                <option value="" hidden>
                                  Select Gear Type
                                </option>
                                <option value="manual">Manual</option>
                                <option value="automatic">Automatic</option>
                              </select>
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Inspection Validity
                              <span>*</span>
                            </label>
                            <div>
                              <DatePicker
                                selected={inspValidity}
                                onChange={handleInspValidityChange}
                                className="trio_mandatory form-control"
                                dateFormat="yyyy-MM-dd"
                                placeholderText="Select Inspection Validity Date"
                                name="insp_validity"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Fuel Type
                              <span>*</span>
                            </label>
                            <div>
                              <select
                                name="fule_type"
                                value={fuleType}
                                className="trio_mandatory form-control"
                                onChange={(e) => handleChange1(e)}
                              >
                                <option value="" hidden>
                                  Select Fuel Type
                                </option>
                                <option value="diesel">Diesel</option>
                                <option value="petrol">Petrol</option>
                                <option value="cng">CNG</option>
                                <option value="Electric(Ev)">
                                  Electric(Ev)
                                </option>
                              </select>
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Company
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="text"
                                name="company"
                                placeholder="Enter Company"
                                value={company}
                                onChange={(e) => setCompany(e.target.value)}
                                className="trio_mandatory form-control"
                              />
                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>

                        {isOtherSelected && (
                          <div className="col-md-6">
                            <div className="inpContainer">
                              <label className="no_prsnl_id">
                                Other Extra Data
                                <span>*</span>
                              </label>
                              <div>
                                <input
                                  type="text"
                                  name="otherExtraData"
                                  placeholder="Enter Other Extra Data"
                                  onChange={handleOtherInputChange}
                                  className="trio_mandatory form-control"
                                />
                                <span className="condition_error"></span>
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="col-md-12 mt-3">
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Overview
                              <span>*</span>
                            </label>
                            <div>
                              <CKEditor
                                editor={ClassicEditor}
                                data={editorData || ""}
                                onChange={handleEditorChange}
                                className="trio_mandatory form-control"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-lg-6 mt-2">
                  {" "}
                  <div className="RightSideData">
                    <div className="rightHeadData">
                      {" "}
                      <h1>Add Images</h1>
                    </div>

                    <div className="imgsData">
                      {images.map((image, index) => (
                        <div className="col-lg-3">
                          <div
                            className="imgContr"
                            key={index}
                            onMouseEnter={() => setHoveredIndex(index)} // Set hovered image index
                            onMouseLeave={() => setHoveredIndex(null)}
                          >
                            <div className="imagePreview">
                              <img src={image} alt={`Uploaded ${index + 1}`} />
                              {hoveredIndex === index && (
                                <div
                                  className="DeleteIcon"
                                  onClick={() => handleImageRemove(index)}
                                >
                                  <FaTrash className="deletSmllIcon" />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                      {carimagemulti.map((image, index) => (
                        <div className="col-lg-3">
                          <div
                            className="imgContr"
                            key={index}
                            onMouseEnter={() => setHoveredIndex(index)} // Set hovered image index
                            onMouseLeave={() => setHoveredIndex(null)}
                          >
                            <div className="imagePreview">
                              <img
                                src={APL_LINK + carimage + image["image"]}
                                alt={`Uploaded ${index + 1}`}
                              />
                              {hoveredIndex === index && (
                                <div
                                  className="DeleteIcon"
                                  onClick={() =>
                                    handleImageRemove(image["image"])
                                  }
                                >
                                  <FaTrash className="deletSmllIcon" />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}

                      {images.length < 8 && (
                        <div className="col-lg-3">
                          <div className="imgContr">
                            <input
                              type="file"
                              name="files"
                              accept="image/*"
                              onChange={handleImageUpload}
                              id="fileInput"
                              style={{ display: "none" }}
                              multiple
                            />
                            <button
                              className="addButton"
                              onClick={() =>
                                document.getElementById("fileInput").click()
                              }
                            >
                              +
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  {" "}
                  <div className="createRightBtnDiv mb-4">
                    <button
                      className="btn btn-primary Create_Designation_Btn btnSave"
                      type="button"
                      onClick={() =>
                        handleSaveChangesdynamic(
                          "createRightsForm",
                          save_car_destails
                        )
                      }
                    >
                      {location.pathname.includes("/edit_cardetails")
                        ? "Update"
                        : "Save"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
